<template>
  <Blog :collection="BlogCollection.NEWS" />
</template>

<script setup lang="ts">
  import { onMounted } from 'vue'
  import { useNuxtApp } from '#imports'

  import { BlogCollection } from '~/constants'

  const { $lenisMount } = useNuxtApp()

  onMounted(() => {
    $lenisMount()
  })
</script>
